import { http } from "@/http/axios.js";
// 站点site
export function getSiteDetailAPI() {
  return http({
    url: '/api/admin/site/detail',
    method: 'get'
  })
}
